export default __webpack_public_path__ + "static/media/mi-settings.dd857491.svg";